<template>
  <li
    class="nav-item px-2 text"
    style="text-align: left"
    :class="{ 'menu-open': seccion_actual == 'lineas' }"
  >

    <a href="#" class="nav-link">
      <i class="nav-icon fas fa-paper-plane"></i>
      <p>Líneas<i class="fas fa-angle-left right"></i></p>
    </a>

    <ul class="nav nav-treeview pl-2">

      <!-- Buscar BL -->
      <li class="nav-item">
        <router-link class="nav-link" to="/lineas/tracking_bookings">
          <i class="nav-icon fas fa-circle text-xs"></i>
          <p>Tracking</p>
        </router-link>
      </li>

      <!-- Buscar BL -->
      <li class="nav-item" v-if="showBuscarBL">
        <router-link class="nav-link" to="/lineas/buscar_bl">
          <i class="nav-icon fas fa-circle text-xs"></i>
          <p>Buscar BL</p>
        </router-link>
      </li>

      <!-- Planificación Anual -->
      <li class="nav-item" v-if="showPlanificaciónAnual">
        <router-link class="nav-link" to="/lineas/planificacion_anual">
          <i class="nav-icon fas fa-circle text-xs"></i>
          <p>Planificación Anual</p>
        </router-link>
      </li>

      <!-- Planificación Semanal -->
      <li class="nav-item" v-if="showPlanificaciónSemanal">
        <router-link class="nav-link" to="/lineas/planificacion_semanal">
          <i class="nav-icon fas fa-circle text-xs"></i>
          <p>Planificación Semanal</p>
        </router-link>
      </li>

      <!-- Servicios -->
      <li class="nav-item" v-if="showServicios">
        <router-link class="nav-link" to="/lineas/servicios">
          <i class="nav-icon fas fa-circle text-xs"></i>
          <p>Servicios</p>
        </router-link>
      </li>

      <!-- Booking -->
      <li
        class="nav-item"
        :class="{ 'menu-open': sub_seccion_actual == 'booking' }"
        v-if="showBooking"
      >
        <a href="#" class="nav-link">
          <i class="nav-icon fas fa-circle text-xs"></i>
          <p>Booking<i class="fas fa-angle-left right"></i></p>
        </a>

        <!-- isAdmin -->
        <ul class="nav nav-treeview pl-2">

          <!-- Booking declarados -->
          <li class="nav-item" v-if="showBookingsDeclarados">
            <router-link
              class="nav-link"
              to="/lineas/booking/bookings_declarados"
            >
              <!-- v-if="isBookingDeclarados" -->
              <i class="nav-icon far fa-circle text-xs"></i>
              <p>Bookings Declarados</p>
            </router-link>
          </li>

          <!-- Bookings Solicitados -->
          <li class="nav-item" v-if="showBookingsSolicitados">
            <router-link
              class="nav-link"
              to="/lineas/booking/bookings_solicitados"
            >
              <!-- v-if="isBookingsSolicitados" -->
              <i class="nav-icon far fa-circle text-xs"></i>
              <p>Bookings Solicitados</p>
            </router-link>
          </li>

          <!-- Bookings Confirmados -->
          <li class="nav-item" v-if="showBookingsConfirmados">
            <router-link
              class="nav-link"
              to="/lineas/booking/bookings_confirmados"
            >
              <!-- v-if="isBookingsConfirmados" -->
              <i class="nav-icon far fa-circle text-xs"></i>
              <p>Bookings Confirmados</p>
            </router-link>
          </li>

          <!-- Solicitudes Modificación -->
          <li class="nav-item" v-if="showSolicitudesModificacion">
            <router-link
              class="nav-link"
              to="/lineas/booking/solicitudes_modificacion"
            >
              <!-- v-if="isSolicitudModificacion" -->
              <i class="nav-icon far fa-circle text-xs"></i>
              <p>Solicitudes Modificación</p>
            </router-link>
          </li>

          <!-- Bookings Embarcados -->
          <li class="nav-item" v-if="showBookingsEmbarcados">
            <router-link
              class="nav-link"
              to="/lineas/booking/bookings_embarcados"
            >
              <!-- v-if="isBookingsEmbarcados" -->
              <i class="nav-icon far fa-circle text-xs"></i>
              <p>Bookings Embarcados</p>
            </router-link>
          </li>

          <!-- Bookings Cancelados -->
          <li class="nav-item" v-if="showBookingsCancelados">
            <router-link
              class="nav-link"
              to="/lineas/booking/bookings_cancelados"
            >
              <!-- v-if="isBookingsCancelados" -->
              <i class="nav-icon far fa-circle text-xs"></i>
              <p>Bookings Cancelados</p>
            </router-link>
          </li>

          <!-- Bookings declarados Cancelados -->
          <li class="nav-item" v-if="showDeclaradosCancelados">
            <router-link
              class="nav-link"
              to="/lineas/booking/ver_Bookings_declarados_cancelados"
            >
              <!-- v-if="isBookingsCancelados" -->
              <i class="nav-icon far fa-circle text-xs"></i>
              <p>Declarados Cancelados</p>
            </router-link>
          </li>

          <!-- Mis Bookings por aceptar -->
          <li class="nav-item" v-if="showMisBookingsPorAceptar">
            <router-link
              class="nav-link"
              to="/lineas/booking/ver_bookings_por_aceptar"
            >
              <!-- v-if="isBookingDeclarados" -->
              <i class="nav-icon far fa-circle text-xs"></i>
              <p>Mis Bookings por aceptar</p>
            </router-link>
          </li>

          <!-- Bookings Solicitados -->
          <li class="nav-item" v-if="showBookingsPorConfirmar">
            <router-link
              class="nav-link"
              to="/lineas/booking/bookings_por_confirmar"
            >
              <!-- v-if="isBookingsSolicitados" -->
              <i class="nav-icon far fa-circle text-xs"></i>
              <p>Bookings por confirmar</p>
            </router-link>
          </li>
        </ul>
      </li>

      <!-- General -->
      <li class="nav-item" v-if="showGeneral">
        <!-- General -->
        <router-link class="nav-link" to="/lineas/general_lineas">
          <i class="nav-icon fas fa-circle text-xs"></i>
          <p>General</p>
        </router-link>
      </li>

      <!-- General extra costos -->
      <li class="nav-item" v-if="showGeneralExtraCostos">
        <!-- General -->
        <router-link class="nav-link" to="/lineas/general_extra_costos">
          <i class="nav-icon fas fa-circle text-xs"></i>
          <p>General Extra Costos</p>
        </router-link>
      </li>


      <!-- Tarifas -->
      <li
        class="nav-item"
        :class="{ 'menu-open': sub_seccion_actual == 'tarifas' }"
        v-if="showTarifas"
      >
        <a href="#" class="nav-link">
          <i class="nav-icon fas fa-circle text-xs"></i>
          <p>Tarifas<i class="fas fa-angle-left right"></i></p>
        </a>
        <ul class="nav nav-treeview">
          <li class="nav-item" v-if="showContratos">
            <!-- Contratos -->
            <router-link class="nav-link" to="/lineas/tarifas/contratos">
              <i class="nav-icon far fa-circle text-xs"></i>
              <p>Contratos</p>
            </router-link>
          </li>

          <li class="nav-item" v-if="showAcuerdosLineas">
            <!-- Acuerdos Líneas -->
            <router-link class="nav-link" to="/lineas/tarifas/acuerdos_lineas">
              <i class="nav-icon far fa-circle text-xs"></i>
              <p>Acuerdos Líneas</p>
            </router-link>
          </li>

          <li class="nav-item" v-if="showAcuerdosClientesBase">
            <!-- Acuerdos Clientes Base -->
            <router-link
              class="nav-link"
              to="/lineas/tarifas/acuerdos_clientes_base"
            >
              <i class="nav-icon far fa-circle text-xs"></i>
              <p>Acuerdos Clientes Base</p>
            </router-link>
          </li>

          <li class="nav-item" v-if="showAcuerdosClientes">
            <!-- Acuerdos Clientes -->
            <router-link
              class="nav-link"
              to="/lineas/tarifas/acuerdos_clientes"
            >
              <i class="nav-icon far fa-circle text-xs"></i>
              <p>Acuerdos Clientes</p>
            </router-link>
          </li>

          <li class="nav-item" v-if="showTarifasLineas">
            <!-- Tarifas Líneas -->
            <router-link class="nav-link" to="/lineas/tarifas/tarifas_lineas">
              <i class="nav-icon far fa-circle text-xs"></i>
              <p>Tarifas Líneas</p>
            </router-link>
          </li>

          <li class="nav-item" v-if="showDescuentosClientes">
            <!-- Tarifas Líneas -->
            <router-link
              class="nav-link"
              to="/lineas/tarifas/descuentos_clientes"
            >
              <i class="nav-icon far fa-circle text-xs"></i>
              <p>Descuentos Clientes</p>
            </router-link>
          </li>

          <li class="nav-item" v-if="showRecargos">
            <!-- Tarifas Líneas -->
            <router-link
              class="nav-link"
              to="/lineas/tarifas/recargos"
            >
              <i class="nav-icon far fa-circle text-xs"></i>
              <p>Recargos</p>
            </router-link>
          </li>

          <li class="nav-item" v-if="showReporteTarifaEmbarcados">
            <!-- Tarifas Líneas -->
            <router-link
              class="nav-link"
              to="/lineas/tarifas/reporte_finanzas"
            >
              <i class="nav-icon far fa-circle text-xs"></i>
              <p>Reporte Finanzas</p>
            </router-link>
          </li>

          <li class="nav-item" v-if="showImportadorCotizaciones">
            <!-- Tarifas Líneas -->
            <router-link
              class="nav-link"
              to="/lineas/tarifas/importador_cotizaciones"
            >
              <i class="nav-icon far fa-circle text-xs"></i>
              <p>Importador Cotizaciones</p>
            </router-link>
          </li>
        </ul>
      </li>

      <!-- Itinearios -->
      <li class="nav-item" v-if="showItinerarios">
        <router-link class="nav-link" to="/lineas/itinerarios">
          <i class="nav-icon fas fa-circle text-xs"></i>
          <p>Itinerarios</p>
        </router-link>
      </li>

      <!-- Tracking -->
      <!-- <li class="nav-item" v-if="showTracking">
        <router-link class="nav-link" to="/lineas/tracking">
          <i class="nav-icon fas fa-circle text-xs"></i>
          <p>Tracking</p>
        </router-link>
      </li> -->


      <!-- Shipping -->
      <li class="nav-item" v-if="showShippingInstruction">

        <a href="#" class="nav-link">
          <i class="nav-icon fas fa-circle text-xs"></i>
          <p>Shipping Instructions<i class="fas fa-angle-left right"></i></p>
        </a>
    
        <ul class="nav nav-treeview" >

          <!-- shipping instructions por enviar -->
          <li class="nav-item" v-if="showShippingInstructionsPorEnviar">
            <router-link class="nav-link" to="/shipping-instructions/shipping-instructions-por-enviar">
              <i class="nav-icon far fa-circle text-xs"></i>
              <p>Shipp. Instruct. por Enviar</p>
            </router-link>
          </li>

          <li class="nav-item" v-if="showShippingInstructionsEnviados">
            <router-link
              class="nav-link"
              to="/shipping-instructions/shipping-instructions-enviados"
            >
              <i class="nav-icon far fa-circle text-xs"></i>
              <p>Shipp. Instruct. Enviados</p>
            </router-link>
          </li>

          <li class="nav-item" v-if="showShippingInstructionsPorAprobar">
            <router-link
              class="nav-link"
              to="/shipping-instructions/shipping-instructions-por-aprobar">
              <i class="nav-icon far fa-circle text-xs"></i>
              <p>Shipp. Instruct. por Aprobar</p>
            </router-link>
          </li>


          <li class="nav-item" v-if="showShippingInstructionsPorRealizar">
            <router-link
              class="nav-link"
              to="/shipping-instructions/shipping-instructions-por-realizar">
              <i class="nav-icon far fa-circle text-xs"></i>
              <p>Shipp. Instruct. por Realizar</p>
            </router-link>
          </li>

          <!-- shipping instructions confirmados -->
          <li class="nav-item" v-if="showShippingInstructionsConfirmados">
            <router-link
              class="nav-link"
              to="/shipping-instructions/shipping-instructions-confirmados"
            >
              <i class="nav-icon far fa-circle text-xs"></i>
              <p>Shipp. Instruct. Confirmados</p>
            </router-link>
          </li>

          <!-- shipping instructions rechazados -->
          <li class="nav-item"  v-if="showShippingInstructionsRechazados">
            <router-link
              class="nav-link"
              to="/shipping-instructions/shipping-instructions-rechazados"
            >
              <i class="nav-icon far fa-circle text-xs"></i>
              <p>Shipp. Instruct. Rechazados</p>
            </router-link>
          </li>

          <!-- shipping instructions templates -->
          <li class="nav-item" v-if="showTemplates">
            <router-link
              class="nav-link"
              to="/shipping-instructions/shipping-instructions-templates"
            >
              <i class="nav-icon far fa-circle text-xs"></i>
              <p>Templates</p>
            </router-link>
          </li>

          <li class="nav-item"  v-if="showReportes">
            <router-link
              class="nav-link"
              to="/shipping-instructions/shipping-instructions-reportes"
            >
              <i class="nav-icon far fa-circle text-xs"></i>
              <p>Reportes</p>
            </router-link>
          </li>
        </ul>
      </li>
    </ul>
  </li>
</template>

<script>
/**
 * @author Miguel González.
 * @description modify role structure. 
 * last modified 18-04-2023 17:25
 */
// Vuex
import { mapState } from "vuex";

export default {
  data() {
    return {
      current_url: "",
      showLineas: false,
      showBuscarBL: false,
      showPlanificaciónAnual: false,
      showPlanificaciónSemanal: false,
      showServicios: false,
      showBooking: false,
      showBookingPlanificado: false,
      showBookingNoPlanificado: false,
      showBookingsDeclarados: false,
      showMisBookingsPorAceptar: false,
      showBookingsPorConfirmar: false,
      showBookingsSolicitados: false,
      showBookingsConfirmados: false,
      showSolicitudesModificacion: false,
      showBookingsEmbarcados: false,
      showLateArrivals: false,
      showVerLateArrivals: false,
      showBookingsCancelados: false,
      showDeclaradosCancelados: false,
      showGeneral: false,
      showGeneralExtraCostos: false,
      showTarifas: false,
      showContratos: false,
      showAcuerdosLineas: false,
      showAcuerdosClientesBase: false,
      showAcuerdosClientes: false,
      showTarifasLineas: false,
      showDescuentosClientes: false,
      showReporteTarifaEmbarcados: false,
      showRecargos: false,
      showImportadorCotizaciones: false,
      showItinerarios: false,
      showSubItinerarios: false,
      showBuscarItinerarios: false,
      showTracking: false,

      showShippingInstruction: false,
      showAñadirShippingInstruction: false,
      showShippingInstructionsPorEnviar: false,
      showShippingInstructionsPorRealizar: false,
      showShippingInstructionsPorAprobar: false,
      showShippingInstructionsEnviados: false,
      showShippingInstructionsConfirmados: false,
      showTemplates: false,
      showShippingInstructionsRechazados: false,
      showReportes: false,

    };
  },
  computed: {
    ...mapState(["url_actual", "seccion_actual", "sub_seccion_actual","isAdmin", "url_actual"]),

    ...mapState("modulosLogin", [
      "roleTree",
      "isLineas",
    ]),

    ...mapState("seccionesLineas", [
      "isBuscarBL",
      "isPlanificacionAnual",
      "isPlanificacionSemanal",
      "isServicios",
      "isBooking",
      "isGeneral",
      "isTarifas",
      "isItinerarios",
      "isTracking",
    ]),

    ...mapState("subseccionesLineas", [
      "isBokingNoPlanificados",
      "isBookingDeclarados",
      "isBookingsSolicitados",
      "isBookingsConfirmados",
      "isSolicitudModificacion",
      "isBookingsEmbarcados",
      "isBookingsCancelados",
      "isVerDeclaradosCancelados",
      "isLateArrivals",
    ]),

    ...mapState("seccionesShippingInstructions", [
      "isPorEnviar",
      "isPorAprobar",
      "isPorRealizar",
      "isEnviados",
      "isConfirmados",
      "isRechazados",
      "isTemplates",
      "isReporte"
    ]),
  },
  methods: {
    superAdmin(){
      this.showLineas = true;
      this.showBuscarBL = true;
      this.showPlanificaciónAnual = true;
      this.showPlanificaciónSemanal = true;
      this.showServicios = true;
      this.showBooking = true;
      this.showBookingPlanificado = true;
      this.showBookingNoPlanificado = true;
      this.showBookingsDeclarados = true;
      this.showMisBookingsPorAceptar = true;
      this.showBookingsPorConfirmar = true;
      this.showBookingsSolicitados = true;
      this.showBookingsConfirmados = true;
      this.showSolicitudesModificacion = true;
      this.showBookingsEmbarcados = true;
      this.showLateArrivals = true;
      this.showVerLateArrivals = true;
      this.showBookingsCancelados = true;
      this.showDeclaradosCancelados = true;
      this.showGeneral = true;
      this.showGeneralExtraCostos = true;
      this.showTarifas = true;
      this.showContratos = true;
      this.showAcuerdosLineas = true;
      this.showAcuerdosClientesBase = true;
      this.showAcuerdosClientes = true;
      this.showTarifasLineas = true;
      this.showDescuentosClientes = true;
      this.showReporteTarifaEmbarcados = true;
      this.showImportadorCotizaciones = true;
      this.showItinerarios = true;
      this.showSubItinerarios = true;
      this.showBuscarItinerarios = true;
      this.showTracking = true;

      this.showShippingInstruction = true;
      this.showAñadirShippingInstruction = true;
      this.showShippingInstructionsPorEnviar = true;
      this.showShippingInstructionsPorAprobar = true;
      this.showShippingInstructionsPorRealizar = true;
      this.showShippingInstructionsEnviados = true;
      this.showShippingInstructionsConfirmados = true;
      this.showTemplates = true;
      this.showShippingInstructionsRechazados = true;
      this.showReportes = true;
    }
  },
  created(){
    if(JSON.parse(localStorage.getItem('user'))?.rol === 'Super Administrador') this.superAdmin();
    const lineasRoleStructure = JSON.parse(localStorage.getItem('roleStructure')).find(({idModule}) => idModule === 1);


    // console.log("lineasRoleStructure-->", lineasRoleStructure);

    // kiosfelix
    if(lineasRoleStructure){
      lineasRoleStructure.sections.map(({ idSection, subSections }) => {

        switch (idSection) {
          case 227: this.showBuscarBL = true; break;
          case 19: this.showPlanificaciónAnual = true; break;
          case 20: this.showPlanificaciónSemanal = true; break;
          case 21: this.showServicios = true; break;
          case 22: this.showBooking = true; //bookings
            subSections.map(({ idSubsection }) => {
              switch (idSubsection) {
                case 59: this.showBookingsDeclarados = true; break;
                case 60: this.showBookingsSolicitados = true; break;
                case 61: this.showBookingsConfirmados = true; break;
                case 62: this.showSolicitudesModificacion = true; break;
                case 63: this.showBookingsEmbarcados = true; break;
                case 64: this.showBookingsCancelados = true; break;
                case 65: this.showDeclaradosCancelados = true; break;
                case 66: this.showLateArrivals = true; break;
                case 67: this.showSolicitudReserva = true; break; // por construir
                case 68: this.showVerLateArrivals = true; break;
                case 69: this.showTracking = true; break;
                case 228: this.showBookingPlanificado = true; break;
                case 229: this.showBookingNoPlanificado = true; break;
                case 230: this.showMisBookingsPorAceptar = true; break;
                case 231: this.showBookingsPorConfirmar = true; break;
                default: break;
              }
            });
            break;
          case 23: this.showGeneral = true; break;
          case 277: this.showGeneralExtraCostos = true; break;
          case 24: //tarifas
            this.showTarifas = true; 
            subSections.map(({ idSubsection }) => {
              switch (idSubsection) {
                case 232: this.showContratos = true; break;
                case 233: this.showAcuerdosLineas = true; break;
                case 234: this.showAcuerdosClientesBase = true; break;
                case 235: this.showAcuerdosClientes = true; break;
                case 236: this.showTarifasLineas = true; break;
                case 237: this.showDescuentosClientes = true; break;
                case 238: this.showReporteTarifaEmbarcados = true; break;
                case 248: this.showRecargos = true; break;
                case 261: this.showImportadorCotizaciones = true; break;
                default: break;
              }
            });
            break;
          case 25: //itinerarios
            this.showItinerarios = true; 
            subSections.map(({ idSubsection }) => {
              switch (idSubsection) {
                case 239: this.showSubItinerarios = true; break;
                case 240: this.showBuscarItinerarios = true; break;
                default: break;
              }
            });
            break;

        }
      })
    }

    const lineasUserStructure = JSON.parse(localStorage.getItem('userStructure')).find(({idModule}) => idModule === 1);
    if(lineasUserStructure){
      lineasUserStructure.sections.map(({ idSection, subSections }) => {
        switch (idSection) {
          case 227: this.showBuscarBL = true; break;
          case 19: this.showPlanificaciónAnual = true; break;
          case 20: this.showPlanificaciónSemanal = true; break;
          case 21: this.showServicios = true; break;
          case 22: //bookings
            this.showBooking = true; 
            subSections.map(({ idSubsection }) => {
              switch (idSubsection) {
                case 59: this.showBookingsDeclarados = true; break;
                case 60: this.showBookingsSolicitados = true; break;
                case 61: this.showBookingsConfirmados = true; break;
                case 62: this.showSolicitudesModificacion = true; break;
                case 63: this.showBookingsEmbarcados = true; break;
                case 64: this.showBookingsCancelados = true; break;
                case 65: this.showDeclaradosCancelados = true; break;
                case 66: this.showLateArrivals = true; break;
                case 67: this.showSolicitudReserva = true; break; // por construir
                case 68: this.showVerLateArrivals = true; break;
                case 228: this.showBookingPlanificado = true; break;
                case 229: this.showBookingNoPlanificado = true; break;
                case 230: this.showMisBookingsPorAceptar = true; break;
                case 231: this.showBookingsPorConfirmar = true; break;
                default: break;
              }
            });
            break;
          case 23: this.showGeneral = true; break;
          case 24: //tarifas
            this.showTarifas = true; 
            subSections.map(({ idSubsection }) => {
              switch (idSubsection) {
                case 232: this.showContratos = true; break;
                case 233: this.showAcuerdosLineas = true; break;
                case 234: this.showAcuerdosClientesBase = true; break;
                case 235: this.showAcuerdosClientes = true; break;
                case 236: this.showTarifasLineas = true; break;
                case 237: this.showDescuentosClientes = true; break;
                case 238: this.showReporteTarifaEmbarcados = true; break;
                default: break;
              }
            });
            break;
          case 25: //itinerarios
            this.showItinerarios = true; 
            subSections.map(({ idSubsection }) => {
              switch (idSubsection) {
                case 239: this.showSubItinerarios = true; break;
                case 240: this.showBuscarItinerarios = true; break;
                default: break;
              }
            });
            break;
          case 69: this.showTracking = true; break;
          default: break;
        }
      })
    }

    if(JSON.parse(localStorage.getItem('user'))?.rol === 'Super Administrador') this.superAdmin();
    const shippingInstructionRoleStructure = JSON.parse(localStorage.getItem('roleStructure')).find(({idModule}) => idModule === 6);
    
    if( shippingInstructionRoleStructure ){
      shippingInstructionRoleStructure.sections.map(({ idSection }) => {
        switch (idSection) {
          case 244: this.showAñadirShippingInstruction = true; break;
          case 43: this.showShippingInstructionsPorEnviar = true; break;
          case 251: this.showShippingInstructionsPorAprobar = true; break;
          case 252: this.showShippingInstructionsPorRealizar = true; break;
          case 44: this.showShippingInstructionsEnviados = true; break;
          case 45: this.showShippingInstructionsConfirmados = true; break;
          case 46: this.showTemplates = true; break;
          case 245: this.showShippingInstructionsRechazados = true; break;
          case 246: this.showReportes = true; break;
          //falta shipping instructions reportes
          //falta shipping instruction rechazados
        
          default:
            break;
        }
      });
    }

    const userRoleStructure = JSON.parse(localStorage.getItem('roleStructure'));
    userRoleStructure.map(({idModule}) => {
      switch (idModule) {
        case 6: this.showShippingInstruction = true; break;
        default: break;
      }
    });

    const userStructure = JSON.parse(localStorage.getItem('userStructure'));
    userStructure.map(({idModule}) => {
      switch (idModule) {
        case 6: this.showShippingInstruction = true; break;
        default: break;
      }
    });

    const shippingInstructionUserStructure = JSON.parse(localStorage.getItem('userStructure')).find(({idModule}) => idModule === 6);

    if( shippingInstructionUserStructure ){
      shippingInstructionUserStructure.sections.map(({ idSection }) => {
        switch (idSection) {
          case 244: this.showAñadirShippingInstruction = true; break;
          case 43: this.showShippingInstructionsPorEnviar = true; break;
          case 251: this.showShippingInstructionsPorAprobar = true; break;
          case 252: this.showShippingInstructionsPorRealizar = true; break;
          case 44: this.showShippingInstructionsEnviados = true; break;
          case 45: this.showShippingInstructionsConfirmados = true; break;
          case 46: this.showTemplates = true; break;
          case 245: this.showShippingInstructionsRechazados = true; break;
          case 246: this.showReportes = true; break;
          //falta shipping instructions reportes
          //falta shipping instruction rechazados
        
          default:
            break;
        }
      });
    }


  }
};

</script>

<style></style>


